import { baseURL } from '../httpService/API';
import { hMacAjax } from 'grt-tool-lib-front';
import { NromalType, WorksListType } from '@/api/Login/type';

export const maiMengLoginUrl = 'https://edu.aijoycloud.com/sso/login?tenant=qihang&p=';
//验证是否是当前学员
export const checkIdentity = (data: NromalType) => {
    return hMacAjax.post(baseURL + '/grt-user-center-service/user/learn-business/v1/project-check', data);
};

//大赛获取配置问卷
export const getQuestionInfo = (data: NromalType) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/exam-practice/user/business/questionnaire/v1', data);
};

//查询赛程和分组
export const getCompetitionPlanInfo = (data: NromalType) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/contest/v1/apply/plan-tree', data);
};

//查询大赛title
export const getCompetitionTitle = (data: NromalType) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/business/v1/title', data);
};

//查询大赛作品的配置列表
export const getWorksList = (data: WorksListType) => {
    return hMacAjax.post(baseURL + '/grt-user-center-service/user/contest/v1/works-list', data);
};

//新增 作品名称
export const addWorkName = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-center-service/user/contest/v1/works', data);
};

//修改 作品名称
export const updateWorkList = (data) => {
    return hMacAjax.put(baseURL + '/grt-user-center-service/user/contest/v1/works', data);
};

// 删除作品
export const deleteWork = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-center-service/user/contest/v1/works-item', data);
};


//协议阅读记录校验
export const getProtocolRecord = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-center-service/user/protocol-reading-record/check', data);
};

//协议内容保存记录
export const saveProtocolRecord = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-center-service/user/protocol-reading-record/save', data);
};


// 公开查询大赛信息
export const getOpenCompetitionInfoApi = (data: NromalType) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/open/business/v1/details', data);
};
// 查询展示规则
export const getCompetitionWorkShowRuleApi = (data: NromalType,id) => {
    return hMacAjax.get(baseURL + `/grt-user-center-service/open/business/works/show/rule/v1/${id}`, data);
};
//查询作品展示列表
export const getCompetitionWorkShowListApi = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-center-service/open/business/works/show/v1/page/search', data);
};

// 查询作品集详情接口

export const getWorkCollectionDetailApi = (data) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/open/business/works/show/v1/details', data);
};

// 画像-大赛菜单
export const getCompetitionMenuConfig = (data) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/competition/menu/config', data);
};

// 画像-查询赛程
export const getCompetitionPortraitStageTree = (data) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/competition/portrait/stage/tree', data);
};

// 画像-查询评语
export const getCompetitionPortraitContents = (data) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/competition/portrait/contents', data);
};

// 画像-查询量表
export const getCompetitionPortraitReview = (data) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/competition/portrait/review', data);
};

// 画像-查询学员信息
export const getCompetitionPortraitStudent = (data) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/competition/portrait/student', data);
};

// 画像-查询分析设置
export const getCompetitionPortraitAnalysisConfig = (data) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/competition/portrait/analysis/config', data);
};

// 画像-讲师评价开关
export const getCompetitionPortraitConfig = (data) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/competition/portrait/config', data);
};

// 画像-查询分析设置
export const userReviewDimScore = (data) => {
    return hMacAjax.post(baseURL + '/dpaas-data-api/user_portrait/chart/user_review_dim_score', data);
};
// 查询业务学员参赛信息
export const getStudentCompeteInfoApi = (data) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/contest/v1/field', data);
};

// 查询业务学员参赛信息并校验是否需要弹出
export const getStudentCompeteInfoAndCheckApi = (data) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/contest/v1/field/check', data);
};
// 修改更新业务学员参赛信息
export const updateStudentCompeteInfoApi = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-center-service/user/contest/v1/field', data);
};
// 查询是否有需要展示的动态字段
export const getIsShowFieldApi = (data) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/contest/v1/field/config', data);
};
// 查询成果奖项配置
export const getPrizeResultConfigApi = (data) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/contest/v1/achievements/config', data);
};
// 查询学员参加大赛获得成果奖项
export const getStudentPrizeResultApi= (data) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/contest/v1/achievements', data);
};
// 对接麦萌查询参数接口
export const getMaimengParamApi= (data) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/user/student/v1/Maimeng/login/redirect/param', data);
};
// 提交赛程作品
export const submitWorksApi= (data) => {
    return hMacAjax.post(baseURL + '/grt-user-center-service/user/contest/v1/submit/works', data);
};